// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "0.0.15/static/js/" + chunkId + "." + "30527eb4" + ".chunk.js";
};